export default "__VITE_ASSET__DSq889ac__"